import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver, EventEmitter,
  Input, OnDestroy,
  OnInit, Output,
  Type,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {Subject} from 'rxjs';
import {CellEditorActionData} from '@shared/models/cell-editor-action-data.model';
import {UpdateHallmarkDataC1B1Command, UpdateHallmarkDataCommand} from '../../commands/dac6-reporter.command';
import {CommandService} from '@core/services/command.service';
import {getApplicationWithId, ParticleState} from '@shared/store/reducers/particle.reduer';
import {Store} from '@ngrx/store';
import {Router} from '@angular/router';
import {DialogService} from "@shared/services/dialog-service";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";

@Component({
    standalone: false,
    selector: 'particle-reporting-logic-single-collapsible-item',
  templateUrl: './reporting-logic-single-collapsible-item.component.html',
  styleUrls: ['./reporting-logic-single-collapsible-item.component.scss']
})
export class ReportingLogicSingleCollapsibleItemComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('dynamicComponent', {read: ViewContainerRef}) viewContainerRef;
  @Input() item: any;
  unSubscribe$ = new Subject<void>();

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
              private commandService: CommandService,
              private dialogService: DialogService,
              private router: Router) {
  }

  ngOnInit() {

  }

  ngAfterViewInit(): void {
    this.loadTemplate();
  }

  loadTemplate() {
    const componentName = this.item.editor;
    const currentComponent = <Type<any>>RootDynamicComponentHelper.getComponent(componentName);
    if (!currentComponent) {
      console.error('no component found');
      return;
    }
    this.viewContainerRef.clear();
    const componentRef = this.viewContainerRef.createComponent(currentComponent);
    const templateComponent = componentRef.instance as any;
    templateComponent.item = this.item;
    if (componentName === 'DynamicTransferBoxComponent') {
      templateComponent.filterId = this.item.arguments.FilterId;
      templateComponent.leftSourceKey = this.item.arguments.LeftSourceKey;
      templateComponent.rightSourceKey = this.item.arguments.RightSourceKey;
      templateComponent.valueChanged.subscribe((value: any) => this.onValueChange(value));
    } else if (componentName === 'DynamicVirtualGridEditorComponent') {
      templateComponent.sourceType = this.item.arguments.SourceKey;
      templateComponent.invalidateSubject = new InvalidateSubject();
      templateComponent.valueChanged.subscribe((value: any) => this.onValueChange({
        ...value,
        invalidateSubject: templateComponent.invalidateSubject
      }));

    }
    else if (componentName === 'HallmarkD2aCellEditorComponent') {
      templateComponent.sourceType = this.item.arguments.SourceKey;
      templateComponent.valueChanged.subscribe((value: any) => this.onValueChange(value));

    }
  }

  onValueChange(event: any) {
    if (event.fieldDefinition && event.fieldDefinition.key === 'dac6countryzerotaxable') {
      this.openCustomCrossborderRate(event.item.cells['Country'].value.code);
      return;
    }
    if (event && event.action && event.action.id) {
      switch (event.action.id) {
        case 'Edit':
          if(event.fieldDefinition.key === 'EU_Countries'){
            const itemCopy = event.item.cells;
            const command = new UpdateHallmarkDataC1B1Command(itemCopy.Country.value.countryCode, itemCopy.EntityCorporateTax.value, itemCopy.EU_Countries.value);
            this.commandService.executeCommand(command).subscribe(state => {
              event.invalidateSubject.invalidate();
            });
          }else{
            this.edit(event);
          }
          break;
      }
    }
  }

  ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  private openCustomCrossborderRate(countryCode: string) {
    this.router.navigateByUrl('rates/certified/cross-border');
  }

  private edit(event: any) {
    this.openEditor(event);
  }

  private openEditor(event: any) {
    let minWidth = '750px';
    const maxWidth = '1500px';
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth, this.item.arguments.SourceKey).subscribe(state => {
      console.log('After Edit', state);
      if (state.action === 'OK') {
        const item = {id: event.item.id, fieldValues: {}};
        const value = event.item.cells[event.fieldDefinition.key].value;
        item.fieldValues[event.fieldDefinition.key] = value;
        let fieldValuesPayload = {};
        fieldValuesPayload[event.fieldDefinition.key]= event.item.cells[event.fieldDefinition.key].value;
        const updateHallMarkdDataCommand = new UpdateHallmarkDataCommand(this.item.id, this.item.hallmarkId,event.item.id, fieldValuesPayload);
        this.commandService.executeCommand(updateHallMarkdDataCommand).subscribe(commandState=>{
          if(commandState){
            console.log('hallmark update');
            event.invalidateSubject.invalidate();
          }
        })
      }
    });
  }
}
